const priceData = {
  coworking: {
    key: "coworking",
    durations: [
      { type: "hour", key: "search.filters.hour", price: [{ min: 0, max: 5 }, { min: 0, max: 10 }, { min: 10, max: null }] },
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 10 }, { min: 0, max: 20 }, { min: 20, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 20 }, { min: 0, max: 30 }, { min: 30, max: null }] },
      { type: "month", key: "search.filters.month", price: [{ min: 0, max: 200 }, { min: 0, max: 300 }, { min: 300, max: null }] },
    ],
  },
  private_office: {
    key: "private_office",
    durations: [
      { type: "hour", key: "search.filters.hour", price: [{ min: 0, max: 10 }, { min: 0, max: 20 }, { min: 20, max: null }] },
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 20 }, { min: 0, max: 40 }, { min: 40, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 40 }, { min: 0, max: 60 }, { min: 60, max: null }] },
      { type: "month", key: "search.filters.month", price: [{ min: 0, max: 200 }, { min: 0, max: 300 }, { min: 300, max: null }] },
    ],
  },
  shared_office: {
    key: "shared_office",
    durations: [
      { type: "hour", key: "search.filters.hour", price: [{ min: 0, max: 10 }, { min: 0, max: 20 }, { min: 20, max: null }] },
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 20 }, { min: 0, max: 40 }, { min: 40, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 40 }, { min: 0, max: 60 }, { min: 60, max: null }] },
      { type: "month", key: "search.filters.month", price: [{ min: 0, max: 400 }, { min: 0, max: 600 }, { min: 600, max: null }] },
    ],
  },
  meeting_room: {
    key: "meeting_room",
    durations: [
      { type: "hour", key: "search.filters.hour", price: [{ min: 0, max: 100 }, { min: 0, max: 200 }, { min: 200, max: null }] },
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 200 }, { min: 0, max: 300 }, { min: 300, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 300 }, { min: 0, max: 500 }, { min: 500, max: null }] },
      { type: "month", key: "search.filters.month", price: [{ min: 0, max: 800 }, { min: 0, max: 1200 }, { min: 1200, max: null }] },
    ],
  },
  seminar: {
    key: "seminar",
    durations: [
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 40 }, { min: 0, max: 80 }, { min: 80, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 60 }, { min: 0, max: 100 }, { min: 100, max: null }] },
      { type: "residential", key: "search.filters.residential", price: [{ min: 0, max: 170 }, { min: 0, max: 500 }, { min: 500, max: null }] },
    ],
  },
  teambuilding: {
    key: "teambuilding",
    durations: [
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 40 }, { min: 0, max: 80 }, { min: 80, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 60 }, { min: 0, max: 100 }, { min: 100, max: null }] },
      { type: "residential", key: "search.filters.residential", price: [{ min: 0, max: 170 }, { min: 0, max: 500 }, { min: 500, max: null }] },
    ],
  },
  conference_room: {
    key: "conference_room",
    durations: [
      { type: "half_day", key: "search.filters.halfDay", price: [{ min: 0, max: 1000 }, { min: 0, max: 3000 }, { min: 3000, max: null }] },
      { type: "day", key: "search.filters.day", price: [{ min: 0, max: 3000 }, { min: 0, max: 7000 }, { min: 7000, max: null }] },
    ],
  },
};

export const getPriceTypes = (usage) => {
  return priceData[usage]?.durations;
};